module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/btn_radio_sp_on-65080a0cc3ce0931f768945a7387cdb8.png";